import { render, staticRenderFns } from "./Spouse.vue?vue&type=template&id=00febbd9&scoped=true&"
import script from "./Spouse.vue?vue&type=script&lang=js&"
export * from "./Spouse.vue?vue&type=script&lang=js&"
import style0 from "./Spouse.vue?vue&type=style&index=0&id=00febbd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00febbd9",
  null
  
)

export default component.exports